module.exports = __webpack_public_path__ + "media/images/h1-a4d2566956b1a8c298d7f5fd9671662b.svg";